import memberLevel from "@/components/shopManage/openModal/memberLevel.vue"
import discountCode from "@/components/shopManage/openModal/discountCode.vue"

export default {
  data() {
    return {
      todayDate: this.$moment().format("YYYY-MM-DD"),
      
      memberLevelTemp: {
        method: "insert",
        data: {},
        show: false
      },

      discountTemp: {
        method: "insert",
        data: {},
        show: false
      }
    };
  },
  methods: {
    getDiscountMethod(code) {
      let infor = "";
      switch (code.discountModel) {
        case "realNumber":
          infor = "現折" + code.discountValue + "元"
          break;
        case "percentage":
          infor = "折扣" + code.discountValue + "折"
          break;
      }

      return infor;
    },

    autoDiscountCode() {
      this.$store.dispatch("cart/autoDiscountCode").then((data) => {
        this.cartSetting.wholeBuilding.code = data;
      });
    },

    baseDiscountSave() {
      this.$store.dispatch("cart/baseDiscountSave", this.cartSetting);
    },

    memberLevelManage(list = {}, method = "insert") {
      this.memberLevelTemp.data = list;
      this.memberLevelTemp.method = method;
      this.memberLevelTemp.show = true;
    },

    discountCodeManage(list = {}, method = "insert") {
      this.discountTemp.data = list;
      this.discountTemp.method = method;
      this.discountTemp.show = true;
    }
  },

  computed: {
    cartSetting: {
      get() {
        return this.$store.state.cart.baseDiscount;
      }
    },

    memberLevel: {
      get() {
        console.log(this.$store.state.cart.memberLevelList);
        return this.$store.state.cart.memberLevelList;
      }
    },

    codeList: {
      get() {
        return this.$store.state.cart.discountCodeList;
      }
    },

    discountRange() {
      const discountRange = [{
        value: "",
        text: "不使用"
      }];
      for (let i = 9.9; i > 0.1; i -= 0.1) {
        discountRange.push({
          value: i.toFixed(1),
          text: i.toFixed(1)
        });
      }
      return discountRange;
    },
    discountCodeState() {
      return (code) => {
        let countState = this.discountCodeNumber(code);
        let checkTime = (code.time.startTime && code.time.startTime < this.todayDate && code.time
          .endTime && code.time.endTime > this.todayDate) || (code.time.startTime && code.time
          .startTime <
          this.todayDate) || (code.time.endTime && code.time.endTime > this.todayDate);

        if (countState.rest == 0) {
          return {
            text: "無剩餘",
            color: "warning"
          }
        } else if (code.useState && checkTime) {
          return {
            text: "可使用",
            color: "success"
          }
        } else if (code.useState && !checkTime) {
          return {
            text: "非使用期間",
            color: "warning"
          }
        } else {
          return {
            text: "不可使用",
            color: "danger"
          }
        }

      }
    },
    discountMethod() {
      return (code) => {
        let infor = "未設定條件";
        let payInfor = this.getDiscountMethod(code);
        switch (code.limitModel) {
          case "buyMoney":
            infor = "消費滿" + code.limitValue + "元，" + payInfor;
            break;
          case "buyCount":
            infor = "消費滿" + code.limitValue + "件，" + payInfor;
            break;
        }

        return infor;
      }
    },

    discountCodeNumber() {
      return (code) => {
        code.rest = (code.rest) ? code.rest : 0;
        return {
          infor: "總數" + code.count + "，剩餘" + code.rest,
          rest: code.rest
        }
      }
    },

    discountCodeTime() {
      return (code) => {
        let time = code.time;
        let start = (time.startTime) ? time.startTime : "無期限";
        let end = (time.endTime) ? time.endTime : "無期限";
        return start + "~" + end;
      }
    }
  },

  created() {
    this.$store.dispatch("cart/getBaseDiscount");
  },

  components: {
    memberLevel,
    discountCode
  }
};
